import React from "react";
import {NewProject_SelectedType} from "../new-project-main";
import ProjectIconUI5 from "../../../../../core/gd-components/icons/project/project-icon-ui5";
import {ItemIconSize} from "../../../../../core/gd-components/icons/@const";

export default function newProject_getMyTemplates() {
    const templates = _.chain(gd.session.templatesList.models)
        .filter(t=>t.companyId === gd.companyId && !t.isDeleted && !t.isPage)
        .orderBy(t=>t.sortPosition)
        .value()

    const res: any = []

    templates.map(template=>{
        res.push({
            id              : template.id,
            typeId          : NewProject_SelectedType.TEMPLATE,
            // icon            : template.iconClass,
            iconComponent   : <ProjectIconUI5 className="option-icon" projectId={template.id} size={ItemIconSize.SIZE_27}/>,
            title           : template.name,
            description     : template.description ? template.description : "No description"
        })
    })

    return res
}
